import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  setI13nData,
  setAlerts,
  createAlert,
  dismissAlert,
  dismissLastAlert,
  setToast,
  switchToast
} from '../../app/actions/common'
import {
  fetchAnnouncements,
  fetchActivities,
  fetchRankingsStats,
  fetchSaleStats,
  fetchOrderCategoryDistribution,
  fetchPaginationBestsellers,
  fetchPageViews,
  fetchServiceDesks,
  fetchShortcuts,
  fetchShortcutSettings,
  updateShortcutSettings,
  fetchPromotions,
  fetchWarehouseOverview,
  fetchBrandDistribution,
  fetchBrandDistributionByBrandId,
  updateSaleStatSettings,
  fetchSalesPerformances,
  fetchSearchKeywords,
  fetchListingPageViews,
  fetchReturns,
  fetchReturnReasonSummaries,
  fetchSpecificReturnReasonsListings,
  fetchSpecificSearchKeywordListings,
  fetchAbandonedCarts,
  fetchArrivalNoticeSummaries,
  fetchListingTags,
  fetchMemberAnalyses,
  fetchSaleStatsByDate,
  fetchListings,
  fetchTrackListings,
  createTrackListings,
  updateTrackListings,
  fetchProductBundles,
  createSupplierCoupons
} from '../../app/actions'
import Dashboard from '../components/Dashboard/Dashboard'
import MobileDashboardCompo from '../components/Dashboard/MobileDashboard'

const mapStateToProps = (state, ownProps) => {
  return {
    env: state.page.env,
    i13nData: state.page.i13nData,
    supplier: state.supplier,
    page: state.page,
    flags: state.flags
  }
}

const mapDispatchToProps = (dispatch) => {
  const actions = Object.assign({
    setI13nData,
    setAlerts,
    createAlert,
    dismissAlert,
    dismissLastAlert,
    setToast,
    switchToast
  }, {
    fetchActivities,
    fetchRankingsStats,
    fetchSaleStats,
    fetchOrderCategoryDistribution,
    fetchPaginationBestsellers,
    fetchPageViews,
    fetchServiceDesks,
    fetchShortcuts,
    fetchShortcutSettings,
    updateShortcutSettings,
    fetchPromotions,
    fetchWarehouseOverview,
    fetchBrandDistribution,
    fetchBrandDistributionByBrandId,
    updateSaleStatSettings,
    fetchSalesPerformances,
    fetchSearchKeywords,
    fetchListingPageViews,
    fetchReturns,
    fetchReturnReasonSummaries,
    fetchSpecificReturnReasonsListings,
    fetchSpecificSearchKeywordListings,
    fetchAbandonedCarts,
    fetchArrivalNoticeSummaries,
    fetchListingTags,
    fetchMemberAnalyses,
    fetchSaleStatsByDate,
    fetchListings,
    fetchTrackListings,
    createTrackListings,
    updateTrackListings,
    fetchProductBundles,
    createSupplierCoupons
  })

  return {
    actions: {
      ...bindActionCreators(actions, dispatch)
    }
  }
}

Dashboard.fetchData = ({ store, req, res }) => {
  const tasks = [
    // 取得重要公告，只先取新到舊 三個，取得普通公告
    store.dispatch(fetchAnnouncements({ limit: 3, type: 'normal' }))
    // APACSMDESK-20096 先關閉
    // // 取得右方及上方宣傳版位上稿資料
    // store.dispatch(supplierActions.fetchPromotions({ id: ['SpHeaderTxt1', 'SpHomeRightImg1'] }))
  ]
  return Promise.all(tasks)
}

const MappedDashboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard)

export const MobileDashboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileDashboardCompo)

export default MappedDashboard
